import { ANALYTICS_MODE } from "../constants/ActivityAnalyticsConstants";

// Server-only when the page views query succeeded and returned no rows: the
// user's browser is not reporting client telemetry for the selected range.
// A failed or still-loading query never switches the mode.
export function resolveAnalyticsMode({ pageViewsSucceeded, pageViewCount }) {
  if (pageViewsSucceeded === true && pageViewCount === 0) {
    return ANALYTICS_MODE.SERVER_ONLY;
  }
  return ANALYTICS_MODE.CLIENT;
}
